import React, { useState, useEffect } from "react";
import { db } from "./firebaseConfig";
import { doc, getDoc } from "firebase/firestore/lite";
import "remixicon/fonts/remixicon.css";
import "aos/dist/aos.css";
import "../../styles/hero.css";
import PDF2 from "../../assets/images/Mohamed_Leachouri_Fullstack_Java_CV_2026_EN.pdf";
import PDF3 from "../../assets/images/Mohamed_Leachouri_Fullstack_Java_CV_2026_FR.pdf";

import Img from "../../assets/images/lea000.JPG";

const Hero = () => {
  const [data, setData] = useState({
    heroTitle: 'Mohamed LEACHOURI',
    heroSubtitle1: 'Java Fullstack Developer',
    heroSubtitle2: 'Software Engineer',
    heroDescription: 'I am a Java Fullstack Web Developer with more than 4 years of experience, specializing in Java, Spring, React and Angular. Additionally, I have a strong background in DevOps practices.',
    resumeUrlEN: PDF2,
    resumeUrlFR: PDF3,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'portfolioData', 'main');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const fetchedData = docSnap.data();
          setData(prev => ({
            ...prev,
            heroTitle: fetchedData.heroTitle || prev.heroTitle,
            heroSubtitle1: fetchedData.heroSubtitle1 || prev.heroSubtitle1,
            heroSubtitle2: fetchedData.heroSubtitle2 || prev.heroSubtitle2,
            heroDescription: fetchedData.heroDescription || prev.heroDescription,
            resumeUrlEN: fetchedData.resumeUrlEN || prev.resumeUrlEN,
            resumeUrlFR: fetchedData.resumeUrlFR || prev.resumeUrlFR,
          }));
        }
      } catch (err) {
        console.error("Error fetching hero data from firebase:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const titleWords = data.heroTitle.split(' ');
  const lastWord = titleWords.pop();
  const restOfTitle = titleWords.join(' ');

  if (loading) {
    return (
      <section
        id="home"
        className="bg-white dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-700 min-h-screen flex items-center justify-center pt-16 pb-12 transition-colors duration-300"
      >
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primaryColor dark:border-primaryColorDark border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-500 dark:text-gray-400 font-medium animate-pulse">Loading hero data...</p>
        </div>
      </section>
    );
  }

  return (
    <section
      id="home"
      className="bg-white dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-700 font-mono 
        text-black dark:text-white min-h-screen flex items-center transition-colors duration-300
        pt-16 pb-12 sm:pt-20 sm:pb-16 md:py-20"
    >
      <div className="container px-4 sm:px-6 pt-8 sm:pt-12 md:pt-14">
        <div className="md:flex items-center justify-between flex-col md:flex-row gap-6 sm:gap-8">
          {/* hero left start */}
          <div
            className="w-full md:w-1/2 order-2 md:order-1"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <div className="mb-3 sm:mb-4">
              <span className="text-primaryColor dark:text-primaryColorDark font-semibold text-base sm:text-lg transition-colors duration-300">
                👋 Hello, I'm
              </span>
            </div>

            <h1
              className="text-gray-800 dark:text-white font-[800] 
              text-[1.75rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[3.5rem] 
              leading-[1.2] mb-3 sm:mb-4 transition-colors duration-300"
            >
              {restOfTitle} <span className="text-primaryColor dark:text-primaryColorDark transition-colors duration-300">{lastWord}</span>
            </h1>

            <div className="mb-4 sm:mb-6">
              <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300">
                <span className="border-b-2 border-primaryColor dark:border-primaryColorDark pb-1 transition-colors duration-300 inline-block">
                  <span className="block sm:inline">{data.heroSubtitle1}</span>
                  <span className="hidden sm:inline"> | </span>
                  <span className="block sm:inline">{data.heroSubtitle2}</span>
                </span>
              </h2>
            </div>

            <div className="bg-white dark:bg-gray-700 border-l-4 border-primaryColor dark:border-primaryColorDark 
                          p-3 sm:p-4 rounded-r-lg shadow-lg mb-6 sm:mb-8 text-gray-700 dark:text-gray-300
                          text-sm sm:text-base md:text-lg leading-relaxed transition-colors duration-300">
              <p>
                {data.heroDescription}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 mb-6 sm:mb-8">
              <a
                href={data.resumeUrlEN}
                className="group inline-flex items-center justify-center px-5 py-3 sm:px-6 bg-primaryColor dark:bg-primaryColorDark text-white  
                font-semibold rounded-lg shadow-lg hover:bg-blue-600 dark:hover:bg-blue-500 active:scale-95
                transition-all duration-300 hover:scale-105 hover:shadow-xl text-sm sm:text-base"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download Resume in English"
              >
                <span className="text-base sm:text-lg">📄</span>
                <span className="ml-2">Resume (EN)</span>
                <span className="ml-2 group-hover:translate-x-1 transition-transform hidden sm:inline">→</span>
              </a>
              <a
                href={data.resumeUrlFR}
                className="group inline-flex items-center justify-center px-5 py-3 sm:px-6 bg-gray-700 dark:bg-gray-600 text-white  
                font-semibold rounded-lg shadow-lg hover:bg-gray-800 dark:hover:bg-gray-500 active:scale-95
                transition-all duration-300 hover:scale-105 hover:shadow-xl text-sm sm:text-base"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download Resume in French"
              >
                <span className="text-base sm:text-lg">📄</span>
                <span className="ml-2">Resume (FR)</span>
                <span className="ml-2 group-hover:translate-x-1 transition-transform hidden sm:inline">→</span>
              </a>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <span className="text-gray-600 dark:text-gray-400 text-sm sm:text-base font-medium whitespace-nowrap">
                Connect with me:
              </span>
              <div className="flex items-center gap-3 sm:gap-4">
                <a
                  title="LinkedIn"
                  href="https://www.linkedin.com/in/leachouri"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-blue-600 text-white p-2.5 sm:p-3 rounded-full
                  hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 active:scale-95
                  text-lg sm:text-xl transition-all duration-300 hover:scale-110 hover:shadow-lg
                  flex items-center justify-center min-w-[44px] min-h-[44px]"
                  aria-label="Visit LinkedIn profile"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a
                  title="GitHub"
                  href="https://github.com/leachouri"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-gray-800 dark:bg-gray-600 text-white p-2.5 sm:p-3 rounded-full
                  hover:bg-gray-900 dark:hover:bg-gray-500 active:scale-95
                  text-lg sm:text-xl transition-all duration-300 hover:scale-110 hover:shadow-lg
                  flex items-center justify-center min-w-[44px] min-h-[44px]"
                  aria-label="Visit GitHub profile"
                >
                  <i className="ri-github-fill"></i>
                </a>
                <a
                  title="Email"
                  href="mailto:leachouri2019@gmail.com"
                  className="bg-red-500 text-white p-2.5 sm:p-3 rounded-full
                  hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700 active:scale-95
                  text-lg sm:text-xl transition-all duration-300 hover:scale-110 hover:shadow-lg
                  flex items-center justify-center min-w-[44px] min-h-[44px]"
                  aria-label="Send email"
                >
                  <i className="ri-mail-fill"></i>
                </a>
              </div>
            </div>
          </div>
          {/* Hero left end */}

          {/* Hero img */}
          <div
            data-aos="fade-left"
            data-aos-duration="1000"
            className="w-full md:w-1/2 flex justify-center md:justify-end order-1 md:order-2 mb-6 sm:mb-8 md:mb-0 mt-0 md:mt-0"
          >
            <figure className="relative max-w-[280px] sm:max-w-[320px] md:max-w-none">
              <div className="absolute inset-0 bg-gradient-to-br from-primaryColor/20 to-blue-600/20 
                            dark:from-primaryColorDark/20 dark:to-blue-500/20 rounded-3xl blur-2xl 
                            transform rotate-6 scale-110 transition-colors duration-300
                            -z-10"></div>
              <img
                className="relative rounded-3xl w-full max-w-[240px] sm:max-w-[280px] md:max-w-[320px] lg:max-w-[384px] h-auto
                shadow-2xl border-4 border-white dark:border-gray-700
                hover:scale-105 transition-all duration-500 ease-in-out 
                transform hover:rotate-1"
                src={Img}
                alt="Mohamed Leachouri - Java Fullstack Developer"
                loading="eager"
              />
              <div className="absolute -bottom-2 sm:-bottom-4 -right-2 sm:-right-4 bg-primaryColor dark:bg-primaryColorDark 
                            text-white px-2 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow-lg animate-pulse transition-colors duration-300
                            text-xs sm:text-sm font-semibold whitespace-nowrap">
                <span className="hidden sm:inline">Available for hire</span>
                <span className="sm:hidden">Available</span>
              </div>
            </figure>
          </div>
          {/* Hero img */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
